import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  PaginationComponent, ImportButton, DownloadButton
} from "@comps/components";
import { makeRequest, makeRequestStateless, handleDownloadFile } from "@utils/helpers";
import { Commons, Const } from "../constants";
import { message, Popconfirm, Tooltip } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { applyIncentiveReq, deleteDataReq, deleteTargetIncentiveConfigReq, getAllDataReq, getFilterReq, getTargetIncetiveConfigReq, updateTargetIncentiveConfigReq } from "./requests";
import { useSelector } from "react-redux";
import CreateSaleIncentive from "./components/CreateSaleIncentive";
//import UpdateSaleIncentives from "./components/UpdateSaleIncentives";
import UpdateSaleIncentive from "./components/UpdateSaleIncentive";
import { UserOutlined } from "@ant-design/icons";
import { checkPermissions } from '@comps/commonFunctions';
import { CalculateOutlined } from "@mui/icons-material";
import { downloadSampleReq } from "../../common/requests";
import ImportSample from "../../common/ImportSample";
import moment from "moment";
import ViewIncentiveEmployees from "./components/ViewIncentiveEmployees";
import CreateTargetIncentiveConfiguration from "./components/CreateTargetIncentiveConfiguration";
import UpdateTargetIncentiveConfiguration from "./components/UpdateTargetIncentiveConfiguration";

const langKey = Const["targetIncentives"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["targetIncentives"].route
      }
    ]
  }
}

const IndexTargetIncentive = (props) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [allData, setAllData] = useState({});
  const [filters, setFilters] = useState(props.attendanceof === 'my' ? `employee_|${authUser.employment_id}` : '');
  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================


  const columns = [
    {
      key: 'title',
      title: trans(`${langKey}.title`),
      dataIndex: 'title'
    },
    {
      key: 'organization_field_name',
      title: trans(`${langKey}.organization_field_name`),
      dataIndex: 'organization_field_name'
    },
    {
      key: 'organization_field_value',
      title: trans(`${langKey}.organization_field_value`),
      dataIndex: 'org_field_display_name'
    },
    {
      key: 'no_of_cases',
      title: trans(`${langKey}.no_of_cases`),
      render: (record) => (
        record.no_of_cases
      )
    },
    {
      key: 'case_price',
      title: trans(`${langKey}.case_price`),
      dataIndex: 'case_price'
    },
    // {
    //   key: 'is_active',
    //   title: "Is Active",
    //   render: (record) => {
    //     return (
    //       <span>{ record.is_active ? "Yes" : "No" }</span>
    //     )
    //   }
    // },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onEdit={ onEdit }
          onView={ onView }
        //onDelete={ onDelete }
        >
          <Tooltip title="Apply or assign this incentive"> <CalculateOutlined className="mt-1" onClick={ () => onApply(record) }>Apply</CalculateOutlined></Tooltip>
          {/* <Popconfirm 
            title="Are you sure you want to compute?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => onApplyIncentive(record)}
          >
           <Tooltip title='Apply/Compute'>
              <CalculateOutlined className="icon-style da-text-color-info-1 ms-3 mt-1" style={ { color: "#1677ff" } }/>
            </Tooltip>
            
          </Popconfirm>
       {
        record.processed &&    <Tooltip title='Employees'>
        <UserOutlined className="icon-style da-text-color-primary-1 ms-3 mt-1" style={ { color: "#1677ff" } } onClick={ () => onViewIncentiveEmployments(record) } />
      </Tooltip>
       } */}
        </ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);
  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: filters
    }
    setChildComponent(null)
    makeRequest(setLoader, getTargetIncetiveConfigReq, payload, onSuccess, onGetAllDataError);
  };
  const onSuccess = (data, res) => {
    setDataSource(data.data);
    setPagination(data)
    message.info(res.message)
  };
  const onGetAllDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const onEdit = (record) => {
    setChildComponent(<UpdateTargetIncentiveConfiguration onCompleted={ onCompleted } record={ record } authUser={ authUser } allData={ allData } disabled={ false } action="update" />);
  };
  const onApply = (record) => {
    setChildComponent(<UpdateTargetIncentiveConfiguration onCompleted={ onCompleted } record={ record } authUser={ authUser } allData={ allData } disabled={ true } action="apply" />);
  }

  const assignToEmployees = (payload) => {
    // const payload = {
    //   id: record.id,
    //   target_incentive_config: { title: record.title }
    // }
    makeRequest(setLoader, updateTargetIncentiveConfigReq, payload, getAllData, onError);
  }
  const onView = (record) => {
    setChildComponent(<UpdateTargetIncentiveConfiguration onCompleted={ onCompleted } record={ record } authUser={ authUser } allData={ allData } disabled={ true } />);
  };

  const onViewIncentiveEmployments = (record) => {
    setChildComponent(<ViewIncentiveEmployees onCompleted={ onCompleted } record={ record } authUser={ authUser } allData={ allData } disabled={ true } />);
  };

  const onApplyIncentive = (record) => {
    const payload = {
      incentive: record
    }
    makeRequest(setLoader, applyIncentiveReq, payload, getAllData, onError);
  };

  const onDelete = (record) => {
    const payload = {
      filters: `employee_|${record.employment_id}`, id: record.id
    }
    makeRequest(setLoader, deleteTargetIncentiveConfigReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    message.success("Record Deleted")
    getAllData();
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateTargetIncentiveConfiguration onCompleted={ onCompleted } authUser={ authUser } allData={ allData } onSuccess={ onSuccess } />);
  };

  const onCompleted = (data) => {

    if (data) {
      getAllData()
    }

    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------
  //download sample log
  const onDownloadSample = () => {
    makeRequestStateless(downloadSampleReq, 'saleIncentives/downloadSalesSample', onSuccessDownloadSample, onSuccessDownloadSample);
  }
  const onSuccessDownloadSample = (res, err) => {
    if (res.code === undefined) {
      // Extract file extension
      const fileExtension = res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'pdf'
      const fileName = `sales_sample.${fileExtension}`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
  }

  return (
    <>

      { childComponent }
      <BodyComponent>
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          {/* <DownloadButton onClick={ onDownloadSample } />
          <ImportButton onClick={ () => setChildComponent(<ImportSample onSuccess={ getAllData } api="saleIncentives/importSalesByBranch" module="Sale Incetives" onCompleted={ () => setChildComponent(null) } />) } /> */}


          {/* <FilterButton onClick={ onOpenFilter } />  */ }
          <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
        </HeaderComponent>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexTargetIncentive;
const filterFields = [
  {
    type: "text",
    placeholder: "Name",
    key: "name"
  },
]

